// window.imagesLoaded

window.imagesLoaded = function(img) {
    let parent = img.parentNode;
    img.complete && parent.classList.add('loaded');
};
